import http from "@/utils/axios";
import { notify } from "@kyvg/vue3-notification";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    warehouseman: [],
    access: [],
    warehousemanCount: null,
    errors: [],
    pagination: {
      currentPage: 1,
      total: 1,
    },
    statuses: [
      {
        id: 1,
        name: "active",
      },
      {
        id: 3,
        name: "blocked",
      },
    ],
    search: "",
    currentWarehouseman: {
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      status: "",
      created_at: "",
      access: [],
    },
  },
  getters: {
    getWarehousemans: (state) => state.warehouseman,
    getWarehousemansCount: (state) => state.warehousemanCount,
    getErrors: (state) => state.errors,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
    getCurrentWarehouseman: (state) => state.currentWarehouseman,
    getStatuses: (state) => state.statuses,
    getStatusById: (state) => (id) => {
      return state.statuses.find((status) => status.id === id);
    },
    getWarehousemanById: (state) => (id) => {
      return state.warehouseman.find((warehouseman) => warehouseman.id === id);
    },
    getAllAccess: (state) => {
      console.log(state.access);
      return state.access;
    },
  },
  mutations: {
    setWarehousemans(state, warehouseman) {
      state.warehouseman = warehouseman.data;
      state.pagination.currentPage = warehouseman.meta.current_page;
      state.pagination.total = warehouseman.meta.last_page;
    },
    setWarehousemansCount(state, count) {
      state.warehousemanCount = count;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    addError(state, { key, error }) {
      state.errors = {
        ...state.errors,
        [key]: error,
      };
    },
    clearErrors(state) {
      state.errors = [];
    },
    setSearch(state, search) {
      state.search = search;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
    setCurrentWarehouseman(state, currentWarehouseman) {
      state.currentWarehouseman = currentWarehouseman;
    },
    setCurrentWarehousemanValue(state, currentWarehouseman) {
      Object.assign(state.currentWarehouseman, currentWarehouseman);
    },
    setCurrentWarehousemanAccess(state, access) {
      state.currentWarehouseman.access = access;
    },
    clearCurrentWarehouseman(state) {
      Object.keys(state.currentWarehouseman).forEach(
        (key) => (state.currentWarehouseman[key] = "")
      );
    },
    clearSearch(state) {
      state.search = "";
    },
    clearWarehousemans(state) {
      state.warehouseman = [];
      state.pagination.currentPage = 1;
      state.pagination.total = 1;
    },
    setAllAccess(state, access) {
      state.access = access;
    },
  },
  actions: {
    async fetchWarehousemans({ commit, state }, { filters, sortBy }) {
      const { data } = await http.get("gatekeeper/warehouseman", {
        params: {
          page: state.pagination.currentPage,
          search: state.search,
          ...filters,
          ...sortBy,
        },
      });
      const warehouseman = data.warehouseman;
      commit("setWarehousemans", warehouseman);
      commit("setWarehousemansCount", warehouseman.meta.total);
    },
    async fetchWarehouseman({ commit, state }, { filters, sortBy }) {
      const { data } = await http.get("gatekeeper/warehouseman", {
        params: {
          page: state.pagination.currentPage,
          search: state.search,
          ...filters,
          ...sortBy,
        },
      });
      const warehouseman = data.warehouseman;
      commit("setWarehousemans", warehouseman);
      commit("setWarehousemansCount", warehouseman.meta.total);
    },

    async changeStatus(_, data) {
      return await http
        .post(`/gatekeeper/warehouseman/${data.id}/change-status`, {
          status: data.status,
        })
        .then(() => {
          notify({
            type: "success",
            text: "messages.save.success",
            duration: 5000,
          });
        })
        .catch(({ response }) => {
          if (response && response.status === 422)
            notify({
              type: "danger",
              text: "messages.save.failure",
              duration: 5000,
            });
        });
    },

    async saveWarehouseman({ commit, state }) {
      return await http
        .post(`/gatekeeper/warehouseman/store`, state.currentWarehouseman)
        .then(() => {
          commit("clearErrors");
          commit("clearCurrentWarehouseman");
          notify({
            type: "success",
            text: "messages.save.success",
            duration: 5000,
          });
          router.push({ name: "WarehousemanList" });
        })
        .catch(({ response }) => {
          if (response && response.status === 422)
            commit("setErrors", response.data.errors);
          notify({
            type: "danger",
            text: "messages.save.failure",
            duration: 5000,
          });
        });
    },

    async updateWarehouseman({ commit, state }, id) {
      await http
        .post(
          `/gatekeeper/warehouseman/${id}/update`,
          state.currentWarehouseman
        )
        .then(() => {
          commit("clearErrors");
          notify({
            type: "success",
            text: "messages.edit.success",
            duration: 5000,
          });
          router.push({ name: "WarehousemanList" });
          commit("clearCurrentWarehouseman");
        })
        .catch(({ response }) => {
          if (response && response.status === 403) {
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
            return;
          }
          if (response && response.status === 422)
            commit("setErrors", response.data.errors);
          notify({
            type: "danger",
            text: "messages.edit.failure",
            duration: 5000,
          });
        });
    },

    async getWarehouseman({ commit }, id) {
      console.log("heere", id);
      return await http
        .get(`gatekeeper/warehouseman/${id}`)
        .then(({ data }) => {
          console.log("data");
          commit("setCurrentWarehouseman", data.admins);
        })
        .catch(({ response }) => {
          if (response && response.status === 403)
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
        });
    },
    async fetchAccessList({ commit }) {
      const response = await http.get("/gatekeeper/warehouseman/access");
      const access = response.data.access;
      commit("setAllAccess", access);
    },
  },
};
